import gsap from "gsap";

export default class Search {
  constructor() {
    this.isOpen = false;
    this.searchInput = document.querySelector(
      "[data-js='header-search'] input",
    );
    this.searchButtonMobile = document.querySelector(
      "[data-js='header-search-mobile']",
    );
    this.searchModal = document.querySelector("[data-js='search-modal']");
    this.searchIconOpen = document.querySelector(
      "[data-js='header-search-mobile__open']",
    );
    this.searchIconClose = document.querySelector(
      "[data-js='header-search-mobile__close']",
    );
    this.content = document.querySelector("[data-js='search-modal__content']");
    this.shadow = document.querySelector("[data-js='search-modal__shadow']");
  }

  init() {
    this.searchInput.addEventListener("focus", this.openSearch.bind(this));
    this.searchButtonMobile.addEventListener(
      "click",
      this.toggleSearch.bind(this),
    );

    this.shadow.addEventListener("click", this.closeSearch.bind(this));
    this.content.addEventListener("click", (event) => {
      event.stopPropagation();
    });
  }

  toggleSearch() {
    this.isOpen ? this.closeSearch() : this.openSearch();
  }

  openSearch() {
    this.isOpen = true;
    this.searchInput.focus();

    this.searchIconOpen.style.display = "none";
    this.searchIconClose.style.display = "block";

    const tl = gsap.timeline();

    tl.set(this.searchModal, {
      display: "block",
      opacity: 0,
    });

    tl.to(this.searchModal, {
      opacity: 1,
      autoAlpha: 1,
    });
  }

  closeSearch() {
    this.isOpen = false;

    this.searchIconOpen.style.display = "block";
    this.searchIconClose.style.display = "none";

    const tl = gsap.timeline();

    tl.to(this.searchModal, {
      autoAlpha: 0,
      onComplete: () => {
        this.searchModal.style.display = "none";
      },
    });
  }
  closeOnOutsideClick(event) {
    if (
      this.isOpen &&
      !event.target.closest("[data-js='header-search'] input") &&
      !event.target.closest("[data-js='header-search-mobile']") &&
      !event.target.closest("[data-js='search-modal']")
    ) {
      this.closeSearch();
    }
  }
}
